"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Billing = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Billing = function Billing() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.8 2.5H1.2C.537 2.5 0 3.032 0 3.688v16.625c0 .655.537 1.187 1.2 1.187h21.6c.663 0 1.2-.532 1.2-1.188V3.688c0-.655-.537-1.187-1.2-1.187zM7.2 19.125c0-2.623-2.149-4.75-4.8-4.75v-4.75c2.651 0 4.8-2.127 4.8-4.75h9.6c0 2.623 2.15 4.75 4.8 4.75v4.75c-2.65 0-4.8 2.127-4.8 4.75H7.2zM8.4 12c0-1.967 1.612-3.563 3.6-3.563s3.6 1.596 3.6 3.563-1.612 3.563-3.6 3.563S8.4 13.966 8.4 12z",
    clipRule: "evenodd"
  });
};

exports.Billing = Billing;